export default {
  fetchDataFailed: "獲取用戶數據失敗，請重試或聯繫支援",
  password_changed_other_tab: "密碼已在其他標籤頁更新",
  profile_updated_other_tab: "個人資料已在其他標籤頁更新",
  report_updated_other_tab: "報告設定已在其他標籤頁更新",
  logged_out_other_tab: "您已在其他標籤頁登出",
  oauth: {
    processing: "正在處理登入請求...",
  },
  ticket: {
    modal_title: "建立工單",
    not_logged_in: "請先登入",
    login_required: "要建立工單，您必須登入您的帳戶。是否前往登入頁面？",
    go_to_login: "前往登入",
    submit_success: "工單提交成功！我們的支援團隊將在 24-48 小時內回覆。",
    email: "電子郵箱",
    email_placeholder: "請輸入您的電子郵箱",
    type: "問題類型",
    type_placeholder: "請選擇問題類型",
    subject: "主題",
    subject_placeholder: "請輸入您的工單主題（5-100 個字元）",
    description: "問題描述",
    description_placeholder: "請詳細描述問題",
    submit_ticket: "提交工單",
    submit_failed: "工單提交失敗！",
    email_send_failed_title: "郵件通知問題",
    email_send_failed_desc:
      "您的工單已成功提交，但我們檢測到發送郵件通知時出現問題。我們的支援團隊仍會處理您的請求。",
  },
};
